import { MessageCircle } from 'lucide-react';
import Avatar from './avatar'; 
import { useGlobalStates } from "../globalConstants";
import { useState, useEffect } from 'react';

export default function ChatHeader() {
  const { messages, playingAudio, isPlaying, socket } = useGlobalStates();
  const [emotion, setEmotion] = useState({ Alex: "neutral", Jordan: "neutral" });

  useEffect(() => {
    socket.emit("get_emotion");

    socket.on("set_emotion", (data) => {
      if (data?.emotion) {
        setEmotion(data.emotion);
      }
    });
  }, [messages, socket]);

  return (
    <div className="border-b border-gray-200 p-4">
      <div className="flex items-center justify-between">
        
        {/* Left Avatar - Alex (Demander) */}
        <Avatar
          name="Alex"
          emotion={emotion.Alex}
          isActive={playingAudio?.speaker === 'Alex' && isPlaying}
          size="small"
        />

        {/* Center Title - Therapist Position */}
        <div className="flex flex-col items-center justify-center">
          <div className="flex items-center space-x-2">
            <MessageCircle className="h-5 w-5 text-primary-600" />
            <h2 className="font-semibold text-gray-900">Therapy Session Chat</h2>
          </div>
          <p className="text-sm text-gray-600 mt-1">
            Alex &amp; Jordan 
          </p>
        </div>

        {/* Right Avatar - Jordan (Withdrawer) */}
        <Avatar
          name="Jordan"
          emotion={emotion.Jordan}
          isActive={playingAudio?.speaker === 'Jordan' && isPlaying}
          size="small"
        />
      </div>
    </div>
  );
}